import Repository from './GetIP'

const resource = "/get"

export default {
  //APIの一覧を記載
  async get(){
    const {data} = await Repository.get(resource)
    return data.origin.toString()
  }

}
